import {PartnerType} from '@br/idm-api';

export type VoidFunction = () => void;
export type SyntheticEventFunction = (e: React.SyntheticEvent) => void;

export declare interface OIDCLogin {
    url: string;
    name: string;
}

export const Party = {
    Bromium: 'bromium',
    Customer: 'customer',
    Distributor: 'distributor',
    Partner: 'partner',
} as const;
export type Party = (typeof Party)[keyof typeof Party];

export declare type OIDCLoginConfiguration = {
    for_party: Party;
    oidc_logins: Array<OIDCLogin>;
    urls: {
        customer_login: string;
        partner_login: string;
        password_login: string;
    };
    allow_password_login: boolean;
    partner_login_enabled: boolean;
};

export declare interface FormError {
    message: string;
    code: string;
}

export declare type FormErrors = Record<string, FormError[]>;

export declare interface Message {
    message: string;
    level: 'debug' | 'info' | 'success' | 'warning' | 'error';
}

// Context types

export type UserData = {
    email: string;
    username: string;
    isHpIdUser: boolean;
    isAzureADUser: boolean;
    hpIdAccountUrl: string;
    isSupportUser: boolean;
    isSupportAdmin: boolean;
    tenants: {
        tenantId: string;
        name: string;
    }[];
    partners: {
        groupId: string;
        name: string;
        partnerType: PartnerType;
    }[];
    preferences?: {
        is_nav_pinned: boolean;
    };
};

export type UserContextType = UserData & {
    singleUserNavigation?: string;
};
